export default "__VITE_ASSET__cDryG4aA__"